export default {
    notes_tab_title: 'Notas',
    notes_tab_created_by: 'Creado Por',
    notes_tab_created_on: 'Creado ',
    notes_tab_updated_by: 'Actualizado Por',
    notes_tab_updated_on: 'Actualizado',
    notes_tab_note: 'Nota',
    notes_tab_edit: 'Editar',
    notes_tab_add_note: 'Agregar Nota',
    notes_tab_project: 'Proyecto'
};